module.exports = __webpack_public_path__ + "static/media/lBanner3.15b450c3.png";